/**
 * @generated SignedSource<<39cb64fcccfd445b67db64bdba2c1ea2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useTodoEditSetTagsMutation$variables = {
  employeeId?: string | null;
  id: string;
  tagIds: ReadonlyArray<string>;
};
export type useTodoEditSetTagsMutation$data = {
  readonly todo: {
    readonly updateTags: {
      readonly todo: {
        readonly id: string;
        readonly tags: ReadonlyArray<{
          readonly id: string;
        }>;
      };
    };
  } | null;
};
export type useTodoEditSetTagsMutation$rawResponse = {
  readonly todo: {
    readonly updateTags: {
      readonly todo: {
        readonly id: string;
        readonly tags: ReadonlyArray<{
          readonly id: string;
        }>;
      };
    };
  } | null;
};
export type useTodoEditSetTagsMutation = {
  rawResponse: useTodoEditSetTagsMutation$rawResponse;
  response: useTodoEditSetTagsMutation$data;
  variables: useTodoEditSetTagsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagIds"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "employeeId",
        "variableName": "employeeId"
      },
      {
        "kind": "Variable",
        "name": "todoId",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoMutation",
    "kind": "LinkedField",
    "name": "todo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "tagIds",
                "variableName": "tagIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "UpdateTodoTagsPayload",
        "kind": "LinkedField",
        "name": "updateTags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTodoEditSetTagsMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTodoEditSetTagsMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "0fa6a87fdc2a753dd46da08ec492e5e7",
    "id": null,
    "metadata": {},
    "name": "useTodoEditSetTagsMutation",
    "operationKind": "mutation",
    "text": "mutation useTodoEditSetTagsMutation(\n  $id: ID!\n  $tagIds: [ID!]!\n  $employeeId: ID\n) {\n  todo(todoId: $id, employeeId: $employeeId) {\n    updateTags(input: {tagIds: $tagIds}) {\n      todo {\n        id\n        tags {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1649d0b8219ca8e5c2495cadeeebd159";

export default node;
